import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { EditProps } from "blocks/types";
import classnames from "classnames";
import React from "react";
import { useBlockStyle } from "../../hooks";

import InspectorControls from "./components/InspectorControls";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		className,
		attributes: {
			label,
			text,
			cssID,
			markup,
			typography,
			size,
			hideOnDesktop,
		},
		setAttributes,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "archive",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const classNames = classnames(
		`mzb-archive mzb-archive-${clientId}`,
		className,
		typography?._className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop"
	);

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div className={classNames}>
				<h2>{__("Archive Title", "magazine-blocks")} </h2>
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default Edit;
